export function afterLifecyleEvents(fn: () => any): void {
    setTimeout(() => {
        fn();
    });
}
